'use es6';

import allSettled from 'hs-promise-utils/allSettled';
import { countSubmissions } from 'FormsUI/api/CrmSearch';
import { getFormSubmissionAnalytics } from '../api/Analytics';
import { getSubmissionStatus } from '../selectors/SubmissionStatus';
function createAction(name) {
  return `@@submissionStatus/${name}`;
}
export const REQUEST_FORM_SUBMISSIONS_COUNT = createAction('REQUEST_FORM_SUBMISSIONS_COUNT');
export const SUCCEED_GETTING_FORM_SUBMISSIONS_COUNT = createAction('SUCCEED_GETTING_FORM_SUBMISSIONS_COUNT');
export const FAIL_GETTING_FORM_SUBMISSIONS_COUNT = createAction('FAIL_GETTING_FORM_SUBMISSIONS_COUNT');
const requestSubmissionsCount = (formGuid, dateRange) => ({
  type: REQUEST_FORM_SUBMISSIONS_COUNT,
  formGuid,
  dateRange
});
const receiveSubmissionsCount = (response, formGuid, dateRange) => ({
  type: SUCCEED_GETTING_FORM_SUBMISSIONS_COUNT,
  response,
  formGuid,
  dateRange
});
const failedFetchingSubmissionsCount = (formGuid, dateRange) => ({
  type: FAIL_GETTING_FORM_SUBMISSIONS_COUNT,
  formGuid,
  dateRange
});
export const fetchFormSubmissionsCount = (formGuid, dateRange) => (dispatch, getState) => {
  if (!getSubmissionStatus(getState(), formGuid, dateRange).requestState.shouldBeRequested()) {
    return Promise.resolve();
  }
  dispatch(requestSubmissionsCount(formGuid, dateRange));
  return allSettled([countSubmissions(formGuid, dateRange), getFormSubmissionAnalytics(formGuid, dateRange.startDate, dateRange.endDate, dateRange.type)]).then(([crmResponse, analyticsResponse]) => {
    if (crmResponse.status === 'rejected') {
      dispatch(failedFetchingSubmissionsCount(formGuid, dateRange));
    } else {
      const noContactRecord = crmResponse.value.skipAssociateContact;
      const filtered = crmResponse.value.filteredInAnalytics + noContactRecord;
      if (analyticsResponse.status === 'rejected') {
        dispatch(receiveSubmissionsCount({
          filtered
        }, formGuid, dateRange));
      } else {
        const notFiltered = crmResponse.value.notFilteredInAnalytics - noContactRecord;
        const processed = analyticsResponse.value.submissions;
        dispatch(receiveSubmissionsCount({
          processing: Math.max(0, notFiltered - processed),
          processed,
          filtered
        }, formGuid, dateRange));
      }
    }
  });
};